import { render, staticRenderFns } from "./Honeymooners.vue?vue&type=template&id=28badbba&"
import script from "./Honeymooners.vue?vue&type=script&lang=js&"
export * from "./Honeymooners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports